import EndlessPossibilities from './EndlessPossibilities';
import SeamlessTeamwork from './SeamlessTeamwork';
import ServiceHero from './ServiceHero';
import ServicesDetails from './ServicesDetails';
import { ServiceContainerStyled, ServicesStyled } from './style';

const Services = () => {
  return (
    <ServicesStyled>
      <ServiceContainerStyled>
        <ServiceHero />
        <ServicesDetails />
        <SeamlessTeamwork />
      </ServiceContainerStyled>
      <EndlessPossibilities />
    </ServicesStyled>
  );
};

export default Services;
